import React from 'react';
import { reducer } from './reducer';
import { StateType, FuelType, ErrorType } from '../../types';
import {
  FormContainerValues,
  FormContainer,
  FormContainerAction,
} from './types';
import { AccountType } from '../../types';
const defaultValue = {
  stateShortName: 'VIC' as StateType,
  customer: {
    customerNumber: '',
    authenticationToken: '',
    fuelSites: [
      {
        fuelType: 'electricity' as FuelType,
        accountNumber: '',
        authAccountNumber: '',
        accountType: null as AccountType,
      },
    ],
  },
  bankBranch: {
    valid: false,
    bsbNumber: '',
    displayName: '',
    hideDisplayName: false,
  },
  error: {
    steps: [
      {
        status: false,
        type: undefined as ErrorType,
      },
    ],
  },
};

export const FormContainerContext: React.Context<FormContainer> = React.createContext(
  {
    values: defaultValue,
    // eslint-disable-next-line
    dispatch: (action: FormContainerAction) => {
      /* this function gets overwritten when context is setup */
    }, // tslint:disable-line
  }
);

export const FormContainerConsumer: React.FunctionComponent<Props> = ({
  initialValue,
  children,
}) => {
  const [state, dispatch] = React.useReducer(reducer, initialValue);

  return (
    <FormContainerContext.Provider value={{ values: state, dispatch }}>
      <FormContainerContext.Consumer>{children}</FormContainerContext.Consumer>
    </FormContainerContext.Provider>
  );
};

interface Props {
  initialValue: FormContainerValues;
  children: (contextProps: FormContainer) => React.ReactNode;
}
